import { EventsBySportIdRequest } from "sb-bff-integration";
export var filterExpiredOutrights = function (x) {
    if (x.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString() && !x.isLive && new Date(x.startEventDate) <= new Date()) {
        return false;
    }
    return true;
};
//# sourceMappingURL=filterExpiredOutrights.js.map